<script setup>
import { inject } from 'vue'

const siteConfig = inject('siteConfig')
const bannerName = 'shop'

</script>

<template>
  <section class="store-shop">
    <div
      class="hero-banner"
      :style="`background-image: url(/sites/${siteConfig.key}/${siteConfig.assets.banners[bannerName] || siteConfig.assets.banners.default})`"
      v-if="!$route.meta.hideHeroImage"
    >
      <div class="container">
        <h1>Shop</h1>
      </div>
    </div>
    <div class="container py-4 md:py-7">
      <RouterView />
    </div>
  </section>
</template>

<style lang="postcss" scoped>
.store-shop {
  :deep() {
    .page-info-component {
      @apply mx-auto text-center max-w-[58rem] mb-4 md:mb-7;
      h2 { @apply text-accent-2 mb-3 }
      p { @apply text-secondary-text }
    }
    .go-back-link {
      @apply inline-flex items-center gap-x-1 py-1.5 px-4 flex-wrap mb-6;
      .icon { @apply w-5 h-5 }
    }
  }
}
</style>